import script from "./CountryOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./CountryOptions.vue?vue&type=script&setup=true&lang=js"

import "./CountryOptions.vue?vue&type=style&index=0&id=39568cc5&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39568cc5"]])

export default __exports__